module.exports = __webpack_public_path__ + "static/media/arrow-right.a11e444a.svg";